import { Outlet, Navigate } from "react-router-dom";
import { userStore } from "../store/Store";

const AdminProtect = () => {
  const currentUser = userStore((data) => data.currentUser);

  return currentUser.role_name === "Systems Admin" ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard" />
  );
};

export default AdminProtect;
